import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetSearchResultsResponse, SearchRequestParams } from "../../interfaces/types"; 


export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: `/arsht-api/search/`
    }),
    endpoints(builder) {
        return {
            getSearchResults: builder.query({
                query: (request: SearchRequestParams) => {
                    let requestString = `GetItems?searchPageId=${request.searchPageId}&keyword=${request.keyword}`
                    if (request.categories && request.categories != '')
                        requestString = requestString + `&categories=${request.categories}`;
                    if (request.contentType != '')
                        requestString = requestString + `&contentTypes=${request.contentType}`;
                    if (request.orderBy && request.orderBy != '')
                        requestString = requestString + `&orderby=${request.orderBy}`;
                    return requestString;
                },
                transformResponse: (response: GetSearchResultsResponse) => {
                    return response;
                }
            })
        };
    },
});

export const { useGetSearchResultsQuery, useLazyGetSearchResultsQuery } = apiSlice;